// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"dca7ce39","159":"bbc7b89d","165":"a8afb68f","271":"b05cbc67","277":"40165928","288":"125ae895","477":"2cc0c70b","607":"3a4afc3a","650":"c2ace8e9","842":"cb85799d"}[chunkId] + ".chunk.js";
};